import { EMPTY_RESEND_RELEASE_PAYMENT_HOLD_MODEL } from "presentation/model/ResendReleasePaymentHold/ResendReleasePaymentHoldModel";
import { useState } from "react";
import { createContainer } from "react-tracked";

const {
    Provider: ResendReleasePaymentHoldProvider,
    useTracked: useResendReleasePaymentHoldTracked
} = createContainer(() => useState(EMPTY_RESEND_RELEASE_PAYMENT_HOLD_MODEL), { concurrentMode: true });
export { ResendReleasePaymentHoldProvider, useResendReleasePaymentHoldTracked };

